
import { defineComponent, onMounted, ref } from "vue";
import { setCurrentPageTitle } from "@/core/helpers/breadcrumb";
import {
  loadPaginatedEstore,
  send_instore,
  isShowRetroPMAButton,
  viewExpiryDate,
} from "@/api/estore";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
import SeqNoticeCard from "@/components/dashboard/sequence/SeqNoticeCard.vue";
import EstoreExpiry from "@/components/estore/EstoreExpiry.vue";

export default defineComponent({
  name: "reorder",
  components: {
    SeqNoticeCard,
    EstoreExpiry,
  },
  props: {
    widgetClasses: String,
  },
  data() {
    return {
      list: [],
      pagination: {
        total: 0,
        per_page: 10,
        current_page: 1,
        last_page: 0,
        from: 1,
        to: 12,
      },
      isBCOAccount: false,
      current_usid: "",
      store_count: [] as string[],
      tousid: [] as string[],
      pos: [] as string[],
      isprocessing: [] as string[],
      retro: "1",
      loading: true,
      isShowRetroPMAButton: false,
      expiry_list: [],
      modal_prodname: "",
    };
  },
  mounted() {
    this.loadPaginatedEstore();
    this.checkIfShowRetroPMAButton();
  },
  methods: {
    async checkIfShowRetroPMAButton() {
      const response = await isShowRetroPMAButton();
      this.isShowRetroPMAButton = response.data.isShowRetroPMAButton;
    },
    async setDefaultValues(listSize: number) {
      let ctr = 0;
      for (ctr = 0; ctr < listSize; ctr++) {
        this.store_count[ctr] = "0";
        this.pos[ctr] = "L";
        this.tousid[ctr] = this.current_usid;
        this.isprocessing[ctr] = "0";
      }
    },
    async viewExpiryDate(pcode, pname) {
      const response = await viewExpiryDate(pcode);
      this.expiry_list = response.data.estoreExpiryDatePageList;
      this.modal_prodname = pname;
    },
    async loadPaginatedEstore() {
      this.loading = true;
      const response = await loadPaginatedEstore(1);
      this.list = response?.data?.pageList || [];
      this.pagination = response?.data?.pagination ?? this.pagination;
      this.isBCOAccount = response?.data?.isBCOAccount ?? false;
      this.current_usid = String(localStorage.getItem("ec_current_usid"));
      let listSize = this.list.length;
      this.setDefaultValues(listSize);
      this.loading = false;
    },
    async send_instore(prod: string, index: number) {
      this.loading = true;
      const store_count = this.store_count[index];
      const tousid = this.tousid[index];
      const pos = this.pos[index];
      const retro = this.retro;

      this.isprocessing[index] = "1";

      var param = {
        store: store_count,
        prod: prod,
        usid: tousid,
        pos: pos,
        retro: retro,
      };
      const response = await send_instore(param);
      if (response != null) {
        if (response.data.result == "SUCCESS") {
          Swal.fire({
            title: "",
            text: response.data.message,
            icon: "success",
            confirmButtonClass: "btn btn-secondary",
          });
          window.location.reload();
          this.isprocessing[index] = "0";
        } else if (response.data.result == "FAILED") {
          Swal.fire({
            title: "",
            text: response.data.message,
            icon: "error",
            confirmButtonClass: "btn btn-secondary",
          });
          this.isprocessing[index] = "0";
        }
      }
      this.loading = false;
      return;
    },
  },
  setup() {
    const tabIndex = ref(0);

    onMounted(() => {
      tabIndex.value = parseInt(localStorage.getItem("retroPMATab") || "0");
      setCurrentPageTitle("Binary Activation");
    });
  },
});
